<template lang="html">
  <div class="container">
    <div class="list_div">
        <CheckboxGroup v-model="check_uids" @on-change="haddleCheckbox" class="check_uids">
          <Table :columns="competitor_columns" :data="competitor_list"></Table>
        </CheckboxGroup>
        <div class="page clear" v-if="total > 10">
            <Page :total="total" :page-size="10" show-total class="page_list" @on-change="handlePage" show-elevator/>
        </div>
        <div class="contrast_div" v-if="competitor_arr.length > 1"></div>
    </div>
    <Spin fix v-if="spinShow">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
    </Spin>
    <div class="contrast" v-if="competitor_arr.length > 1">
      <p class="contrast_t">公司详情对比</p>
      <div class="contrast_c">
          <div class="contrast_l">
              <div class="c_li" v-for="item in com_list" :key="item.uid">
                  <div class="logo_img">
                      <img :src="item.logo_path | logo_show" />
                  </div>
                  <div class="com_name">
                      <p>{{item.short_name}}</p>
                  </div>
                  <div class="com_a">
                      <a @click="haddleDeteleCom(item.uid)" v-if="item.uid != uid">删除</a>
                  </div>
              </div>
              <div class="c_li c_li2" v-if="com_list.length <= 3">
                  <div class="logo_img">1</div>
                  <div class="com_name">
                      <p>您还可以继续添加</p>
                  </div>
              </div>
              <div class="c_li c_li2" v-if="com_list.length == 2">
                  <div class="logo_img">2</div>
                  <div class="com_name">
                      <p>您还可以继续添加</p>
                  </div>
              </div>
          </div>
          <div class="c_btn">
              <a @click="haddleCompare()" onclick="_czc.push(['_trackEvent', '公司详情', '公司对比点击'])">对比</a>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { entityDetail,entityCompare } from '../../../service'
import filter from 'js/filter'
export default {
  inject: ['reload'],
  data() {
    return {
      spinShow: true,
      check_uids: [],
      params: {
        uid: this.$route.params.uid,
        type: 'competitor',
        entity_type: 0,
        page: 1
      },
      params_com: {
        uids: []
      },
      com_list: [],
      competitor_list: [],
      competitor_arr: [],
      total: 0,
      competitor_columns: [
        { title: '公司名称',width: 180, render: (h, params) => {
          return h('div',{
              class: {company: true}
            },[
            h('div',
              {
                class: {logo_img: true},
                on: {click: () => {this.goEntityDetail(params.row.uid, params.row.type)}},
              },[
                h('img', { attrs: {src: filter.logo_show(params.row.logo_path)}})
              ]),
            h('div',
              {class: {company_name: true}},[
                h('p', [
                  h('a',{
                    on: {click: () => {this.goEntityDetail(params.row.uid, params.row.type)}}
                  }, params.row.short_name)
                ]),
              ])
          ])
        }},
        // {title: '领域',minWidth: 100,render: (h, params) => {
        //   return h('span', filter.dealString(params.row.tags, 'dynview_tag'))
        // }},
        {
          title: '简要介绍',
          minWidth: 100,
          render: (h, params) => {
            return h('div', {
              class: {
                'dec-clamp': true
              }
            }, filter.empty(params.row.description))
          }
        },
        { title: '地区',width: 90, render: (h, params) => {
          return h('span', filter.addressDeal(params.row.address_id, '2'))
        }},
        { title: '成立时间',width: 100, render: (h, params) => {
          return h('span', filter.timeTrans(params.row.setup_time))
        }},
        { title: '当前轮次',width: 80, key: 'round_id', render: (h, params) => {
          return h('span', filter.deal(params.row.round_id, 'round'))
        }},
        { title: '最新获投时间',width: 110, render: (h, params) => {
          return h('span', filter.timeTrans(params.row.latest_event.event_time))
        }},
        { title: '融资金额',width: 80, render: (h, params) => {
          let latest_event = params.row.latest_event
          return h('span', filter.amountPrecise(latest_event.amount, latest_event.unit_id, latest_event.precise))
        }},
        { title: '投资方',minWidth: 120, render: (h, params) => {
          if(params.row.latest_event.tzf && params.row.latest_event.tzf.length > 0){
            let tzf = []
            params.row.latest_event.tzf.map((a,index) => {
              if(a.type != '2'){
                tzf.push(h('a', {on: {click: () => {this.goEntityDetail(a.uid, a.type)}}}, a.short_name))
              }else{
                tzf.push(h('span', a.short_name))
              }
              if(index < params.row.latest_event.tzf.length-1) tzf.push(h('span', '、'))
            })
            return tzf
          }else{
            return h('span','未透露')
          }
        }},
        { title: '选择对比',width: 88, align: 'center', render: (h, params) => {
          return h('Checkbox', {
              props: {
                label: params.row.uid
              },
            })
        }}
      ]
    }
  },
  computed: {
    uid() {
      return this.$route.params.uid
    }
  },
  methods: {
    async getDetail() {
      let res = await entityDetail(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res.status == 'success') {
        this.$set(this.$data, 'competitor_list', res.rival_comps)
        if(this.competitor_list.length > 0) this.$emit('callbackData', 'Competitor')
        if(res.count > 30 ){
          this.total = 30
        }else{
          this.total = res.count
        }
      } else {
        this.$Message.error(res.msg)
      }
      this.spinShow = false
    },
    async getComList() {
      this.params_com.uids = this.competitor_arr
      let res = await entityCompare(this.params_com, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res.status == 'success') {
        this.$set(this.$data, 'com_list', res.res)
      } else {
        this.$Message.error(res.msg)
      }
    },
    haddleCheckbox() {
      if(this.check_uids.length > 3){
        this.check_uids = this.check_uids.slice(0, 3)
        this.$Message.warning('已经添加3家公司');
      }
    },
    haddleDeteleCom(uid) {
      let index = this.check_uids.findIndex(a => {return a == uid})
      this.check_uids.splice(index, 1)
    },
    haddleCompare() {
      // console.log(this.competitor_arr)
      // this.$router.push({name: 'CompanyCompare', query: {uids: this.competitor_arr}})
      const { href } = this.$router.resolve({
        name: "CompanyCompare",
        query: {uids: this.competitor_arr}
      })
      window.open(href, '_blank')
    },
    handlePage(index) {
      this.params.page = index
      // document.body.scrollTop = 0
      // document.documentElement.scrollTop = 0
      this.spinShow = true
      this.getDetail()
    },
    goEntityDetail(uid, type) {
      if (type == 2) {
        // this.$router.push({name: 'PeoDetail', params: {uid: uid}})
        const { href } = this.$router.resolve({
          name: "PeoDetail",
          params: {
            uid: uid
          }
        })
        window.open(href, '_blank')
      } else if(type == 1){
        // this.$router.push({name: 'OrgDetail', params: {uid: uid}})
        const { href } = this.$router.resolve({
          name: "OrgDetail",
          params: {
            uid: uid
          }
        })
        window.open(href, '_blank')
      } else if(type == 0){
        // this.$router.replace({name: 'CompanyDetail', params: {uid: uid}})
        const { href } = this.$router.resolve({
          name: "CompanyDetail",
          params: {
            uid: uid
          }
        })
        window.open(href, '_blank')
      } else if(type == 3){
        // this.$router.push({name: 'HospitalDetail', params: {uid: uid}})
        const { href } = this.$router.resolve({
          name: "HospitalDetail",
          params: {
            uid: uid
          }
        })
        window.open(href, '_blank')
      }
    },
  },
  created() {
    this.getDetail()
  },
  watch: {
    uid(val) {
      this.spinShow = true
      this.getDetail()
    },
    check_uids(arr) {
      this.competitor_arr = [].concat([this.uid], arr)
      this.getComList()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'

.container
  & >>> .ivu-checkbox-checked .ivu-checkbox-inner
    commonBorderColor(rgba(250, 122, 80, 1), #23294D)
    commonBgColor(rgba(250, 122, 80, 1), #23294D)
  & >>> .ivu-checkbox-focus
    box-shadow: none
.list_div
  padding: 40px 32px 40px
  .check_uids
    >>> .ivu-checkbox
      &+span
        display: none
      .ivu-checkbox-inner
        background-color: transparent
        commonBorderColor(#7A7F94, #D5D5D5)
      &.ivu-checkbox-checked
        .ivu-checkbox-inner
          border: 1px solid
          commonBorderColor(rgba(250, 122, 80, 1), #23294D)
          commonBgColor(rgba(250, 122, 80, 1), #23294D)
          &:after
            border-color: #fff !important
  .contrast_div
    width: 100%
    height: 124px
.contrast
  position: fixed
  width: 1048px
  height: 124px
  commonBgColor(#2D2F34, #FFFFFF)
  commonShadow(0 -4px 20px 0 rgba(0,0,0,.5), 0px -4px 20px 0px rgba(121,133,143,.1))
  bottom: 16px
  left: 50%
  margin-left: -448px
  padding: 20px
  z-index: 99999
  .contrast_t
    font-size: 16px
    commonColor(#fa7a50, #333333)
    font-weight: 500
  .contrast_c
    padding-top: 16px
    display: flex
    .contrast_l
      flex: auto
      display: flex
      .c_li
        flex: 0 0 217px
        border-right: 1px dashed
        commonBorderColor(#57595D, #D5D5D5)
        margin-right: 20px
        display: flex
        .logo_img
          flex: 0 0 50px
          height: 50px
          line-height: 48px
        .com_name
          flex: auto
          margin-left: 12px
          padding-top: 18px
          p
            commonColor(#BCBDC1, #333333)
            font-size: 14px
            width: 105px
            ellipsis()
        .com_a
          flex: 0 0 48px
          text-align: center
          padding-top: 19px
          a
            color: rgba(250, 122, 80, 1)
            cursor: pointer
      .c_li2
        .logo_img
          commonColor(#797B83, #CCCCCC)
          commonBgColor(#323646, #F9F9F9)
          commonBorderColor(#323646, #F9F9F9)
          font-size: 24px
        .com_name
          p
            commonColor(#BCBDC1, #999999)
            width: auto
    .c_btn
      flex: 0 0 60px
      a
        background: rgba(250, 122, 80, 1)
        border-radius: 2px
        width: 60px
        height: 28px
        display: block
        line-height: 28px
        color: #fff
        margin: 11px auto 0
        text-align: center
.list_div
  & >>> .ivu-table
    th:last-child
    td:last-child
      .ivu-table-cell
        padding-right: 20px
</style>
